<template>
	<span> {{ formatDate }} </span>
</template>
<style>

</style>
<script>
import moment from 'moment';

export default {
    props: ['value'],
    computed: {
        formatDate() {               
            return moment.utc(this.value).local().format('D MMM YYYY H:mm') ;
        }
    }
};
</script>


// WEBPACK FOOTER //
// resources/js/metronic/table/value/Date.vue